"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.matchingBracketsInput = exports.default = exports.calculateTrueCursorPosition = exports.adjustTrueCursorOutsideFieldBoundary = exports.Style = exports.MAX_WIDTH = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = _interopRequireWildcard(require("react"));
var _breakpoints = require("../../style/breakpoints");
var _classnames = _interopRequireDefault(require("classnames"));
var _recompose = require("recompose");
var _reactMentions = require("react-mentions");
var _injectSheet = _interopRequireDefault(require("../../style/injectSheet"));
var _theme = _interopRequireDefault(require("../../style/theme"));
var _InputRequired = _interopRequireDefault(require("../InputRequired/InputRequired"));
var _excluded = ["data-testid", "appendSpaceOnAdd", "classes", "className", "data", "defaultValue", "description", "disabled", "displayErrors", "displayTransform", "hasError", "hasRequired", "hasSuccess", "hasValidation", "inputRef", "markup", "mentionInputClassName", "name", "onChange", "readOnly", "regex", "renderSuggestion", "required", "theme", "trigger", "triggerElement"];
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2.default)(o), (0, _possibleConstructorReturn2.default)(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2.default)(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; } /*:: // 

import { type ComponentType, type ElementRef, type Node, type Ref } from 'react';*/ /*:: import { type CSS, type ThemeType, type InjectSheetProvidedProps } from '../../style/ThemeTypes';*/
var DISPLAY_NAME = 'TokenPickerInput';
var MAX_WIDTH = exports.MAX_WIDTH = '20rem'; // 320px

var Style = exports.Style = function Style(theme /*: ThemeType*/) {
  return {
    root: _objectSpread(_objectSpread(_objectSpread({}, theme.mixins.inputStyle), theme.mixins.breakWord), {}, {
      paddingTop: 0,
      paddingBottom: 0,
      position: 'relative',
      minHeight: '3rem',
      width: 'auto'
    }),
    mentionInput: {
      hyphens: 'none',
      margin: 0,
      '& li': {
        borderTop: "1px solid ".concat(theme.colors.lightGrey),
        '&:first-child': {
          borderTop: 0
        }
      },
      '& textarea, & input': {
        paddingTop: theme.functions.toRem(theme.variables.inputPaddingTop),
        paddingBottom: theme.functions.toRem(theme.variables.inputPaddingTop),
        paddingLeft: '.125rem',
        paddingRight: '.125rem',
        backgroundColor: 'inherit',
        outline: 'none',
        border: 0,
        width: '100%!important'
      },
      marginRight: '1rem'
    },
    menuItem: _objectSpread(_objectSpread({}, theme.typography.extraSmallText), {}, {
      display: 'flex',
      flexWrap: 'wrap',
      alignItems: 'center',
      minWidth: '10rem',
      minHeight: '2.5rem',
      padding: '.5rem 1rem',
      color: theme.colors.black,
      listStyle: 'none',
      textAlign: 'left',
      cursor: 'pointer',
      verticalAlign: 'bottom',
      '&:focus, &:hover': {
        backgroundColor: theme.colors.blueGrey
      },
      '& > div': {
        width: '100%',
        '& > span': {
          display: 'inline-block',
          overflow: 'hidden'
        }
      }
    }),
    focused: {
      backgroundColor: theme.colors.blueGrey
    },
    hiddenTextarea: {
      display: 'none'
    },
    displayErrors: {
      '&:valid': theme.mixins.inputSuccess,
      '&:invalid': theme.mixins.inputError
    },
    success: theme.mixins.inputSuccess,
    error: theme.mixins.inputError,
    required: {
      right: '2.5rem'
    },
    helpOpener: {
      color: theme.colors.battleshipGrey,
      height: '1.25rem',
      width: '1.25rem'
    },
    descriptionContainer: {
      bottom: '0.8rem',
      display: 'inline-flex',
      position: 'absolute',
      right: '0.8rem',
      '& > .tippy-popper': {
        minWidth: '15rem'
      }
    },
    description: _objectSpread(_objectSpread({}, theme.typography.smallText), {}, {
      wordBreak: 'break-word',
      padding: '1rem',
      textAlign: 'left',
      maxWidth: '15rem'
    })
  };
};
var makeStyles = function makeStyles(_ref /*:: */) {
  var renderFromClick = _ref /*:: */.renderFromClick,
    screenSize = _ref /*:: */.screenSize;
  var styles
  /*: {
      highlighter: CSS,
      suggestions: CSS,
      mentionHighlight: CSS,
      ['&multiLine']: CSS
    }*/
  = {
    highlighter: {
      border: 0,
      paddingTop: _theme.default.functions.toRem(_theme.default.variables.inputPaddingTop),
      paddingBottom: _theme.default.functions.toRem(_theme.default.variables.inputPaddingTop),
      paddingLeft: '.125rem',
      paddingRight: '.125rem'
    },
    suggestions: _objectSpread(_objectSpread({}, _theme.default.mixins.inputMenu), {}, {
      maxHeight: '12.25rem',
      marginTop: '1.875rem',
      overflow: 'auto',
      border: "1px solid ".concat(_theme.default.colors.blueGrey),
      borderRadius: _theme.default.variables.borderRadiusSmall,
      boxShadow: "0 .25rem .5rem ".concat(_theme.default.colors.pastelGreyAlpha),
      backgroundColor: _theme.default.colors.white,
      maxWidth: MAX_WIDTH,
      zIndex: _theme.default.zIndex.menu
    }),
    mentionHighlight: {
      backgroundColor: _theme.default.colors.highlightAlpha,
      borderRadius: '.15rem'
    },
    '&multiLine': {
      input: {
        '&[readonly]': {
          '&, &:focus, &:hover': _theme.default.mixins.inputReadOnly
        },
        '&:disabled': {
          '&, &:focus, &:hover': _theme.default.mixins.inputDisabled
        }
      }
    }
  };
  if (renderFromClick && screenSize > _breakpoints.devices.mobile.landscape) {
    styles.suggestions.position = 'absolute';
    styles.suggestions.top = '100%';
    styles.suggestions.right = 0;
    styles.suggestions.left = 'auto';
    styles.suggestions.marginTop = '.5rem';
  }
  return styles;
};
/*:: type TokenPickerInputType = InjectSheetProvidedProps &
  HTMLTextAreaElement & {
    'data-testid'?: string,
    appendSpaceOnAdd?: boolean,
    suggestionLocationOnClick: ElementRef<*>,
    data: Array<any>,
    defaultValue?: any,
    description?: Node,
    displayErrors: boolean,
    displayTransform?: (id: string, display: string) => string,
    hasError: boolean,
    hasRequired: boolean,
    hasSuccess: boolean,
    hasValidation?: boolean,
    inputRef?: Ref<*>,
    markup: string,
    mentionInputClassName?: string,
    onChange: (event: Object) => mixed,
    regex?: RegExp,
    renderSuggestion: (suggestion: any) => Node,
    trigger: string | RegExp,
    triggerElement?: Node
  };*/
/*:: type State = {
  inputValue: string,
  renderFromClick: boolean
};*/
// Helper to determine cursor location to insert field
var calculateTrueCursorPosition = exports.calculateTrueCursorPosition = function calculateTrueCursorPosition(currentValue /*: string*/, currentCursorPlacement /*: number*/, displayStarterText /*: string*/) {
  var displayText = displayStarterText.slice(0, currentCursorPlacement) || '';
  var displayedDoubleBracketsMatches = displayText.match(/{{|}}/g) || [];
  var displayedDoubleBrackets = displayedDoubleBracketsMatches.length * 2 || 0;
  var trueCursor = currentCursorPlacement;
  while (currentValue.slice(0, trueCursor).replace(/{{|}}/g, '').length + displayedDoubleBrackets < currentCursorPlacement && trueCursor < currentValue.length) {
    trueCursor++;
  }
  return trueCursor;
};

// Helper to determine if inserting field would split a pre-existing field
var adjustTrueCursorOutsideFieldBoundary = exports.adjustTrueCursorOutsideFieldBoundary = function adjustTrueCursorOutsideFieldBoundary(trueCursor /*: number*/, currentValue /*: string*/) /*: number*/{
  var inBetweenFields;
  trueCursor === 0 ? inBetweenFields = false : inBetweenFields = true;
  while (inBetweenFields) {
    var _starterText$match, _starterText$match2;
    var starterText = currentValue.slice(0, trueCursor);
    var leftBrackets = ((_starterText$match = starterText.match(/}}/g)) === null || _starterText$match === void 0 ? void 0 : _starterText$match.length) || 0;
    var rightBrackets = ((_starterText$match2 = starterText.match(/{{/g)) === null || _starterText$match2 === void 0 ? void 0 : _starterText$match2.length) || 0;
    if (leftBrackets === rightBrackets) {
      inBetweenFields = false;
    } else {
      trueCursor++;
    }
  }
  return trueCursor;
};
var matchingBracketsInput = exports.matchingBracketsInput = function matchingBracketsInput(currentValue /*: string*/) /*: boolean*/{
  var _currentValue$match, _currentValue$match2;
  return ((_currentValue$match = currentValue.match(/}}/g)) === null || _currentValue$match === void 0 ? void 0 : _currentValue$match.length) === ((_currentValue$match2 = currentValue.match(/{{/g)) === null || _currentValue$match2 === void 0 ? void 0 : _currentValue$match2.length);
};
var TokenPickerInput = /*#__PURE__*/function (_PureComponent) {
  function TokenPickerInput() {
    var _this;
    (0, _classCallCheck2.default)(this, TokenPickerInput);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, TokenPickerInput, [].concat(args));
    (0, _defineProperty2.default)(_this, "state", {
      inputValue: _this.props.defaultValue === null || _this.props.defaultValue === undefined ? '' : typeof _this.props.defaultValue === 'string' ? _this.props.defaultValue.replace(/\r\n/gi, '\n') : _this.props.defaultValue.toString(),
      renderFromClick: false
    });
    (0, _defineProperty2.default)(_this, "textInput", (0, _react.createRef)());
    (0, _defineProperty2.default)(_this, "suggestionLocationOnClick", (0, _react.createRef)());
    (0, _defineProperty2.default)(_this, "handleClick", function (e) {
      var _this$textInput$curre;
      var textInput = _this.textInput.current;
      var displayedText = ((_this$textInput$curre = _this.textInput.current) === null || _this$textInput$curre === void 0 ? void 0 : _this$textInput$curre.defaultValue) || '';
      if (!textInput) {
        return null;
      }
      e.preventDefault();
      var currentValue = _this.state.inputValue || '';
      var currentCursorPlacement = (textInput === null || textInput === void 0 ? void 0 : textInput.selectionEnd) || 0;
      var displayStarterText = displayedText.slice(0, currentCursorPlacement);
      if (matchingBracketsInput(currentValue)) {
        var _starterText$match3, _displayStarterText$m;
        var trueCursor = calculateTrueCursorPosition(currentValue, currentCursorPlacement, displayStarterText);
        var adjustedCursor = adjustTrueCursorOutsideFieldBoundary(trueCursor, currentValue);
        var displayTextOffSetOfCursor = adjustedCursor - trueCursor;
        trueCursor = adjustedCursor;
        var starterText = currentValue.slice(0, trueCursor);
        var amountOfBrackets = ((_starterText$match3 = starterText.match(/{{|}}/g)) === null || _starterText$match3 === void 0 ? void 0 : _starterText$match3.length) || 0;
        // Adjust Display text to match offset from adjusting cursor within fields
        displayStarterText = displayedText.slice(0, currentCursorPlacement + displayTextOffSetOfCursor);
        var displayedDoubleBrackets = ((_displayStarterText$m = displayStarterText.match(/{{|}}/g)) === null || _displayStarterText$m === void 0 ? void 0 : _displayStarterText$m.length) || 0;
        var hiddenBrackets = (amountOfBrackets - displayedDoubleBrackets) * 2;
        var firstHalf = (starterText && starterText.slice(-1) !== ' ' ? starterText + ' ' : starterText) + '{{';
        var updatedText = firstHalf + currentValue.slice(trueCursor);
        textInput.focus();
        _this.setState({
          inputValue: updatedText
        }, function () {
          textInput.selectionStart = firstHalf.length - hiddenBrackets;
          textInput.selectionEnd = firstHalf.length - hiddenBrackets;
        });
      } else {
        textInput.focus();
        var _updatedText = (_this.state.inputValue && _this.state.inputValue.slice(-1) !== ' ' ? _this.state.inputValue + ' ' : _this.state.inputValue) + '{{';
        _this.setState({
          inputValue: _updatedText
        });
        textInput.selectionStart = textInput.value.length;
        textInput.selectionEnd = textInput.value.length;
      }
    });
    (0, _defineProperty2.default)(_this, "handleChange", function (event /*: Object*/) {
      var _this$props = _this.props,
        id = _this$props.id,
        name = _this$props.name,
        onChange = _this$props.onChange;
      var inputValue = (event.target.value || '').replace(/\r\n/gi, '\n');
      _this.setState({
        inputValue: inputValue,
        renderFromClick: false
      });
      if (onChange) {
        onChange({
          currentTarget: {
            id: id,
            name: name,
            value: inputValue
          }
        });
      }
    });
    return _this;
  }
  (0, _inherits2.default)(TokenPickerInput, _PureComponent);
  return (0, _createClass2.default)(TokenPickerInput, [{
    key: "render",
    value: function render() {
      var _document$body,
        _this2 = this;
      var _this$props2 = this.props,
        dataTestID = _this$props2['data-testid'],
        appendSpaceOnAdd = _this$props2.appendSpaceOnAdd,
        classes = _this$props2.classes,
        className = _this$props2.className,
        data = _this$props2.data,
        defaultValue = _this$props2.defaultValue,
        description = _this$props2.description,
        disabled = _this$props2.disabled,
        displayErrors = _this$props2.displayErrors,
        displayTransform = _this$props2.displayTransform,
        hasError = _this$props2.hasError,
        hasRequired = _this$props2.hasRequired,
        hasSuccess = _this$props2.hasSuccess,
        hasValidation = _this$props2.hasValidation,
        inputRef = _this$props2.inputRef,
        markup = _this$props2.markup,
        mentionInputClassName = _this$props2.mentionInputClassName,
        name = _this$props2.name,
        onChange = _this$props2.onChange,
        readOnly = _this$props2.readOnly,
        regex = _this$props2.regex,
        _renderSuggestion = _this$props2.renderSuggestion,
        required = _this$props2.required,
        theme = _this$props2.theme,
        trigger = _this$props2.trigger,
        triggerElement = _this$props2.triggerElement,
        props = (0, _objectWithoutProperties2.default)(_this$props2, _excluded);
      var _this$state = this.state,
        inputValue = _this$state.inputValue,
        renderFromClick = _this$state.renderFromClick;
      var hasValue = inputValue && typeof inputValue === 'string' && inputValue.length > 0;
      var isRequired = required && !hasValue;
      var mentionDataTestID = dataTestID ? "".concat(dataTestID, "-tokenPickerInput") : 'tokenPickerInput';
      var screenSize = ((_document$body = document.body) === null || _document$body === void 0 ? void 0 : _document$body.clientWidth) || 0;
      var style = makeStyles({
        renderFromClick: renderFromClick,
        screenSize: screenSize,
        disabled: disabled,
        readOnly: readOnly
      });
      return /*#__PURE__*/_react.default.createElement("div", {
        className: (0, _classnames.default)(classes.root, (0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)({}, classes.error, hasError || displayErrors && isRequired), classes.displayErrors, displayErrors), classes.success, hasSuccess || displayErrors && !isRequired), className),
        "data-testid": mentionDataTestID
      }, /*#__PURE__*/_react.default.createElement(_reactMentions.MentionsInput, (0, _extends2.default)({
        suggestionsPortalHost: renderFromClick && screenSize > _breakpoints.devices.mobile.landscape ? this.suggestionLocationOnClick.current : null,
        className: (0, _classnames.default)(classes.mentionInput, mentionInputClassName),
        "data-testid": dataTestID || 'mention-input',
        disabled: disabled,
        onChange: this.handleChange,
        readOnly: readOnly,
        required: required,
        style: style,
        value: inputValue,
        inputRef: this.textInput
      }, props), /*#__PURE__*/_react.default.createElement(_reactMentions.Mention, {
        appendSpaceOnAdd: appendSpaceOnAdd,
        data: data,
        displayTransform: displayTransform,
        markup: markup,
        trigger: trigger,
        regex: regex,
        renderSuggestion: function renderSuggestion(/* This order is important */
        suggestion, search, highlightedDisplay, index, focused) {
          return /*#__PURE__*/_react.default.createElement("div", {
            className: (0, _classnames.default)(classes.menuItem, (0, _defineProperty2.default)({}, classes.focused, focused))
          }, _renderSuggestion(suggestion));
        },
        style: style.mentionHighlight
      })), /*#__PURE__*/_react.default.createElement("textarea", {
        className: classes.hiddenTextarea,
        "data-testid": "mention-hidden-textarea",
        id: name,
        name: name,
        readOnly: true,
        ref: inputRef,
        required: required,
        value: inputValue
      }), isRequired && /*#__PURE__*/_react.default.createElement(_InputRequired.default, {
        className: classes.required,
        disabled: disabled,
        hasRequired: hasRequired,
        readOnly: readOnly,
        required: required
      }), triggerElement && !disabled && !readOnly && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", {
        className: classes.descriptionContainer
      }, /*#__PURE__*/_react.default.createElement("div", {
        role: "button",
        tabIndex: 0,
        onKeyPress: function onKeyPress(e) {
          _this2.setState({
            renderFromClick: true
          });
          _this2.handleClick(e);
        },
        onClick: function onClick(e) {
          _this2.setState({
            renderFromClick: true
          });
          _this2.handleClick(e);
        }
      }, triggerElement)), /*#__PURE__*/_react.default.createElement("div", {
        ref: this.suggestionLocationOnClick
      }, " ")));
    }
  }]);
}(_react.PureComponent);
(0, _defineProperty2.default)(TokenPickerInput, "displayName", DISPLAY_NAME);
(0, _defineProperty2.default)(TokenPickerInput, "defaultProps", {
  disabled: false,
  displayErrors: false,
  hasError: false,
  hasRequired: true,
  hasSuccess: false,
  readOnly: false,
  required: false
});
/*:: type EnhancedProps = {
  appendSpaceOnAdd?: boolean,
  data: Array<any>,
  'data-testid'?: string,
  defaultValue?: any,
  description?: Node,
  displayErrors?: boolean,
  displayTransform?: (id: string, display: string) => string,
  hasError?: boolean,
  hasRequired?: boolean,
  hasSuccess?: boolean,
  inputRef?: Ref<*>,
  markup: string,
  mentionInputClassName?: string,
  regex?: RegExp,
  renderSuggestion: (suggestion: any) => Node,
  trigger: string | RegExp,
  triggerElement?: Node
};*/
var EnhancedTokenPickerInput /*: ComponentType<EnhancedProps>*/ = (0, _recompose.compose)((0, _recompose.setDisplayName)(DISPLAY_NAME), (0, _injectSheet.default)(Style))(TokenPickerInput);
var _default = exports.default = EnhancedTokenPickerInput;
//# sourceMappingURL=TokenPickerInput.js.map